import React from 'react'
import { connect } from 'react-redux'
import Stats from 'components/ListView/task/Stats'

export default connect(
	(state) => ({ task: state.tasks.tasksByID?.[state.tasks.addOrEdit?.taskID] }),
	null,
)(({ task }) => {
	const stats = task?.email_stats
		? 'email_stats'
		: task?.sms_stats
		? 'sms_stats'
		: null

	if (task && stats) {
		return (
			<div style={{ padding: 10, zoom: '200%' }}>
				<Stats
					typeID={task.task_type_id}
					stats={task[stats]}
					taskID={task.id}
				/>
			</div>
		)
	}

	return <div>No stats for this task yet!</div>
})
